import React from 'react';
import { Link } from 'react-router-dom';

const skillSheets = [
  {
    name: 'Oxygen Tank',
    path: '/oxygen-skill',
    description: 'Oxygen Tank Setup + O2 Administration',
  },
  {
    name: 'Nasal Cannula',
    path: '/nasal-cannula',
    description: 'Nasal Cannula Skill Sheet',
  },
  {
    name: 'Non Rebreather',
    path: '/non-rebreather',
    description: 'Non Rebreather Skill Sheet',
  },
];

const SkillSheetsDashboard = () => (
  <div className="min-h-screen bg-bg text-text flex flex-col items-center py-8">
    <h1 className="text-2xl font-bold mb-6 text-primary">Skill Sheets Dashboard</h1>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-4xl">
      {skillSheets.map(sheet => (
        <Link
          key={sheet.path}
          to={sheet.path}
          className="block bg-tableRow border border-gray-300 rounded-xl shadow hover:shadow-lg hover:bg-accent/10 transition-all duration-200 p-6 text-center"
        >
          <h2 className="text-xl font-semibold mb-2">{sheet.name}</h2>
          <p className="text-base text-text/70">{sheet.description}</p>
        </Link>
      ))}
    </div>
  </div>
);

export default SkillSheetsDashboard;
